export function portfolioHasErrors(portfolio) {
    return getPortfolioSettingsErrors(portfolio).length > 0 ||
        getPortfolioValuesErrors(portfolio).length > 0 ||
        getPortfolioContributionsErrors(portfolio).length > 0 ||
        getPortfolioBenchmarkErrors(portfolio).length > 0
}

export function getPortfolioSettingsErrors(portfolio) {

    var ret = [];

    if (!portfolio.name) {
        ret.push("Portfolio name required");
    }

    if (!portfolio.startMonth || !portfolio.startYear || !portfolio.endMonth || !portfolio.endYear) {
        ret.push("Dates not set");
    }
    else if (portfolio.startYear > portfolio.endYear || (portfolio.startYear === portfolio.endYear && portfolio.startMonth >= portfolio.endMonth)) {
        ret.push("End date must be past start date");
    }

    return ret;
}

export function getPortfolioValuesErrors(portfolio) {

    var ret = [];

    var set = true;

    portfolio.portfolioValues.filter((e, i) => i !== 0).forEach(element => {
        set = set && element.value;
    });

    if (!set) {
        ret.push("All portfolio values are required");
    }

    return ret;
}

export function getPortfolioContributionsErrors(portfolio) {

    var ret = [];

    var set = true;

    portfolio.contributions.forEach(element => {
        set = set && (element.feePaidToManager || element.contribution || element.securitiesTransferred || element.cashWithdrawl);
    });

    if (!set) {
        ret.push("At least one contribution value is required per date");
    }

    return ret;
}

export function getPortfolioBenchmarkErrors(portfolio) {

    var ret = [];

    var benchmark = portfolio.benchmarks.find(e => e.key === "clientSpecified" && e.selected === true);

    if (benchmark) {
        const sum = !benchmark ? 0 : 0 + (benchmark.oneMonthTbill ? parseFloat(benchmark.oneMonthTbill) : 0) +
            (benchmark.mainIndex ? parseFloat(benchmark.mainIndex) : 0) +
            (benchmark.secondaryIndex ? parseFloat(benchmark.secondaryIndex) : 0) +
            (benchmark.tenYearBond ? parseFloat(benchmark.tenYearBond) : 0);

        if (sum !== 1) {
            ret.push("Client specified contributions must equal 100%");
        }
    }

    return ret;
}


export function formatCell(data, format = "percent", percentDigits = 2) {
    if(data === '-Infinity')
        return data;
    if (!data || data === null || data === "NaN" || data === "Infinity") {
        return data;
    }

    if (format === "percent" || format === "%") {
        return (data * 100).toFixed(percentDigits) + '%'
    }
    else if (format === "dec") {
        return (data).toFixed(percentDigits)
    }
    else if (format === "$") {
        return "$" + (data).toFixed(2);
    }

    if (Math.round(data) === data) {
        return data;
    }

    return data.toFixed(format);
}


// WEBPACK FOOTER //
// ./src/portfolio/components/portfolioHelpers.js